module.exports = __webpack_public_path__ + "img/orator-pro-logo.95cc8841.svg";